<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col add_user_btn">
            <a class="btn btn-success" (click)="showModal()"><i class="fa fa-file-excel"></i> Import Partner Lead</a>
        </div>
    </div>
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-2">
                        <input class="form-control" [(ngModel)]="search" type="text" placeholder="Search" />
                    </div>
                    <div class="col-sm-2">
                        <mat-select placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')"
                            multiple>
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2">
                        <mat-select placeholder="Lead Source" [(ngModel)]="lead_source"
                            (click)="setSearchValue('lead_source')" multiple>
                            <input class="mySearchInput" #leadsourceSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_source')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="leadsourceSearch">
                            <mat-option value="{{lsources.id}}" *ngFor="let lsources of lead_sources">
                                {{lsources.source_name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2">
                        <mat-select placeholder="Lead Status" [(ngModel)]="lead_status_search"
                            (click)="setSearchValue('lead_status')" multiple>
                            <input class="mySearchInput" #lead_status_Search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'lead_status')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="lead_status_Search">
                            <mat-option [value]="lstatus.id" *ngFor="let lstatus of leadallStatus">{{lstatus.name}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadPertnerList(0,perpage)">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                            class="fa fa-sync"></i> Reset Filters</button>
                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-8 p-3">
                    <button type="button" class="btn btn-success ml-2 mb-4" [disabled]="loading"
                        (click)="loadPertnerList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh Sheet</button>
                </div>
                <div class="col-sm-4">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="text-center" *ngIf="loading"><i class="fa fa-spin fa-spinner fa-2x"></i></div>
            <hot-table [hotId]="id" [colHeaders]="true" [hiddenColumns]="hideColumn" [columnSorting]="false"
                width="100%" [height]="600" [rowHeaders]="true" [data]="leadsList" [beforeChange]="onBeforeChange"
                licenseKey="non-commercial-and-evaluation" [afterOnCellMouseDown]="afterOnCellMouseDownCallBack" [autoWrapRow]="false" [autoWrapCol]="false">
                <hot-column class="bg-red" style="background: red" data="id" [readOnly]="true" title="ID"></hot-column>
                <hot-column data="name" [readOnly]="true" title="Lead Name"></hot-column>
                <hot-column width="100" [copyable]="false" data="mobile" renderer="html" [readOnly]="true"
                    title="Lead Mobile">
                </hot-column>
                <hot-column data="patient_age" title="Patient Age"></hot-column>
                <hot-column data="gender" type="dropdown" [source]="gender" title="Gender"></hot-column>
                <hot-column data="circle_name" type="dropdown" [source]="sheetCircle" title="To Circle"></hot-column>
                <hot-column data="city_name" [readOnly]="true" title="City Name"></hot-column>
                <hot-column data="treatment_name" type="dropdown" [source]="treatments" title="Treatment"></hot-column>
                <!--------Kaleyra Click to Call----------->
                <hot-column renderer="html" data="click_to_call" [readOnly]="true" title="Kaleyra C2C"></hot-column>

                <hot-column width="250" data="lead_status_name" type="dropdown" [source]="leadStatus" title="Status">
                </hot-column>
                <hot-column data="lead_source" renderer="html" [readOnly]="true" title="Lead Source"></hot-column>
                <hot-column data="created_at" [readOnly]="true" title="Lead Created Time"></hot-column>
                <hot-column data="description" title="Description" width="300"></hot-column>
                <hot-column data="action" width="200px" type="dropdown" [source]="ActionOpt" title="Action"></hot-column>
            </hot-table>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>
    </div>
</div>

<!-- The Modal -->
<div class="modal fade" id="myModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Import Partner Lead </h4>
                <button type="button" class="close" (click)="hideModal()"></button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <label class="col-sm-12">Upload CSV</label>
                        <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)"
                            class="form-control" />
                    </div>
                    <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
                </div>
                <div class="form-group" [innerHTML]="uploaded_msg | safe:'html'">

                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn" (click)="hideModal()">Close</button>
            </div>
        </div>
    </div>
</div>

<!-----------------For Click to Call-------------------------->
<div class="modal fade" id="click_to_call_progress" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Call Progression</h4>
        </div>
  
        <!-- Modal body -->
          <div class="">
                <div class="alert alert-danger" *ngIf="progression_msg">
                  <strong>Warning!</strong> {{progression_msg}}
                </div>
                <div class="form-group">
                  <div class="row">
                    <div style="font-size: 18px;" class="col-sm-12 modal-title text-center" id="click_to_call_progress_html">
                      <i class="fa fa-cog fa-spin"></i><br />
                      <h2>Call is under progress.</h2>
                    
                    </div>
                  </div>
                </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" [disabled]="end_to_call_btn_disable" class="btn btn-success" (click)="endClicktoCall()">Close</button>
        </div>
      </div>
    </div>
  </div>